<template>
  <div class="select">
    <div :class="[
        'select-wrapper',
        {'select-wrapper--active': isOpen},
        ]" @click="$event.target.closest('.select-option') ? isOpen = false : isOpen = !isOpen">
      <div class="select-field" :style="{width: customWidth || false}">
        <div v-if="currentSelected.icon" class="select-field__icon-left">
                <svg
                    width="1em"
                    height="1em"
                    class="icon icon-gb"
                    :style="{
                    width: '18px',
                    height: '18px',
                    marginRight: '8px',
                  }">
                  <use
                      :xlink:href="
                      '/images/useful/svg/theme/symbol-defs.svg#' +
                      currentSelected.icon
                    "></use>
                </svg>
              </div>
        <span class="select-field__name"
              :style="{padding: currentSelected.icon ? '0' : '0 1.2rem'}"
        >
          {{ currentSelected.name }}
        </span>
        <span class="select-field__icon">
          <svg
              width="1em"
              height="1em"
              class="icon icon-chevron">
            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
          </svg>
        </span>
      </div>
      <div class="select-body">
        <div class="select-body__inner js-scrollbar">
          <div
              v-for="item in items"
              :key="item.id"
              :class="[
                      'select__option',
                      {'select__option--selected': item.id === currentSelected.id},
                    ]"
              @click="selectItem(item)">
            <span class="select-option__name">
              <span v-if="item.icon">
                <svg
                    width="1em"
                    height="1em"
                    class="icon icon-gb"
                    :style="{
                    width: '18px',
                    height: '18px',
                    marginRight: '8px',
                  }">
                  <use
                      :xlink:href="
                      '/images/useful/svg/theme/symbol-defs.svg#' +
                      item.icon
                    "></use>
                </svg>
              </span>
              <span>{{ item.name }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClassicSelect",
  props: ['items', 'selectedItem', 'customWidth'],
  data() {
    return {
      isOpen: false,
      currentSelected: this.selectedItem || this.items[0],
    }
  },
  methods: {
    selectItem(item) {
      this.currentSelected = this.items.find((i) => i.id === item.id);
      this.$emit('select-item', item);
    },
    closeSelectBody(event) {
      if (!event.target.closest('.select-wrapper')) {
        this.isOpen = false
      }
    }

  },
  mounted() {
    window.addEventListener('click', this.closeSelectBody)
    this.$emit('select-item', this.currentSelected);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.closeSelectBody)
  }
}
</script>

<style scoped lang="scss">
.select {
  position: relative;

  &-wrapper {
    &--active .select-body {
      display: block;
    }

    &--active .select-field__icon .icon-chevron {
      transform: rotate(180deg);
      transition: transform 0.3s ease, color 0.3s ease;
    }
  }

  &-field {
    width: 20rem;
    height: 3.6rem;
    background-color: #fff;
    border-radius: 3px;
    border: 1px solid #bcbcbc;
    display: flex;
    cursor: pointer;

    &__icon-left {
      display: flex;
      align-items: center;
      margin-left: 12px;
    }

    &__name {
      display: block;
      text-align: left;
      width: calc(100% - 3.6rem);
      height: 100%;
      font-size: 1.2rem;
      line-height: 2.8em;
      font-weight: 500;
      color: #1b1b1b;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      outline: none;
    }

    &__icon {
      width: 3.6rem;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fafafa;
      border-radius: 0 3px 3px 0;
      position: relative;

      & .icon-chevron {
        transition: transform 0.3s ease, color 0.3s ease;
        font-size: 8px;
      }
    }
  }

  &-body {
    width: 100%;
    border-radius: 0 0 3px 3px;
    background-color: #fff;
    border: 1px solid #bcbcbc;
    margin-top: -1px;
    box-shadow: 0px 2px 2px rgb(0 0 0 / 15%);
    display: none;
    position: absolute;
    left: 0;
    top: 3.6rem;
    z-index: 105;

    &__inner {
      padding: 5px 0;
      max-height: 25rem;
      overflow: hidden;
      overflow-y: auto;
    }
  }

  &__option {
    font-weight: 500;
    padding: 3px 1.2rem;
    font-size: 1.2rem;
    line-height: 1.5em;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: rgba(27, 27, 27, 0.6);
    transition: color 0.3s ease;

    &:hover {
      color: #1b1b1b;
    }

    &-name {
      display: block;
      width: 100%;
    }

    &--selected {
      color: #1b1b1b;
    }
  }
}
</style>